module.exports = __webpack_public_path__ + "img/step1.8169b69.png";